
import { computed, defineComponent, PropType, ref, toRef, watch } from "vue";
import { TranslationService } from "@/core/services/TranslationService";
import VZModal from "@/components/content/VZModal.vue";
import { IRoleCount } from "@/interfaces/iRole";
import { ICurrentUser } from "@/interfaces/iCurrentUser";
import { UserAPI } from "@/services/api/User.service";
import VZFilter from "@/components/kt-datatable/components/VZFilter.vue";
export default defineComponent({
  name: "UserRoleModal",
  emits: ["close-user-modal"],
  components: { VZModal, VZFilter },
  props: {
    value: { type: Boolean, default: false },
    viewName: { type: String, default: "" },
    data: {
      type: Object as PropType<IRoleCount>,
      required: true,
      default: () => {
        return {};
      },
    },
    showDialog: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const data = toRef(props, "data");
    const loading = ref(false);
    const items = ref<ICurrentUser[]>([]);
    const searchTerm = ref<string>("");
    const defaultFilter = ref({});
    const VZRoleFilter = ref();
    const siteIds = ref();
    const userIds = ref();
    const title = computed(() => {
      return props?.data?.label;
    });
    const id = computed(() => {
      return props?.data?.value;
    });
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const tableFilter = computed(() => {
      return [
        {
          key: "userIds",
          label: TranslationService.translate("common.users"),
          type: "lookup",
          attrs: {
            mode: "tags",
          },
          url: id.value
            ? `/security/filter/USERS_BY_ROLE?siteIds=${id.value}`
            : null,
          textKey: "text",
          valueKey: "value",
        },
        {
          key: "siteIds",
          label: TranslationService.translate("common.sites"),
          type: "lookup",
          attrs: {
            mode: "tags",
          },
          url: id.value
            ? `/site/filter/SITES_BY_ROLES?userId=${id.value}`
            : null,
          textKey: "text",
          valueKey: "value",
        },
      ];
    });
    const onFilterChange = async (filters) => {
      userIds.value = filters.userIds;
      siteIds.value = filters.siteIds;
      await getData();
    };

    const close = () => {
      searchTerm.value = "";
      emit("close-user-modal");
      items.value = [];
    };
    // watch(
    //   data,
    //   async (newVal, oldVal) => {
    //     getData();
    //   },
    //   { deep: true }
    // );
    const getData = async () => {
      try {
        loading.value = true;
        const params = new URLSearchParams();
        if (searchTerm.value) params.append("search", searchTerm.value);
        if (userIds.value?.length > 0)
          params.append(
            "filterUserIds",
            userIds.value.map((id) => id).join(", ")
          );
        if (siteIds.value?.length > 0)
          params.append(
            "filterSiteIds",
            siteIds.value.map((id) => id).join(", ")
          );

        const queryString = params.toString();
        items.value = await UserAPI.getInstance().getUsersOnRoleId(
          data.value.value as any,
          queryString as any
        );
      } catch (e) {
        console.log(e);
      } finally {
        loading.value = false;
      }
    };
    const search = () => {
      if (searchTerm.value.length > 2 || searchTerm.value.length == 0) {
        getData();
      }
    };
    watch(
      () => props.showDialog,
      (newVal) => {
        if (newVal) {
          loading.value = true;
          searchTerm.value = "";
          userIds.value = undefined;
          siteIds.value = undefined;
        }
      }
    );
    return {
      t,
      title,
      id,
      close,
      loading,
      items,
      tableFilter,
      onFilterChange,
      getData,
      searchTerm,
      search,
      defaultFilter,
      VZRoleFilter,
    };
  },
});
